

const heroTimers = new WeakMap();

function initProcladHero(root) {
  const prev = heroTimers.get(root);
  if (prev) prev.forEach(clearInterval);
  const timers = [];
  heroTimers.set(root, timers);

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = window.Shopify && window.Shopify.designMode;
  if (reduced || designMode) return;

  const track = root.querySelector('[data-hero-ticker]');
  const hex = root.querySelector('[data-hero-hex]');
  const reviewWraps = [...root.querySelectorAll('[data-hero-review], [data-hero-review-mobile]')]
    .map((reviewWrap) => ({
      reviewWrap,
      texts: [...reviewWrap.querySelectorAll('[data-review-text]')],
      rIdx: 0,
    }))
    .filter((r) => r.texts.length > 1);

  const swapReviews = () => {
    reviewWraps.forEach((r) => {
      r.reviewWrap.style.opacity = '0';
      setTimeout(() => {
        r.texts[r.rIdx].hidden = true;
        r.rIdx = (r.rIdx + 1) % r.texts.length;
        r.texts[r.rIdx].hidden = false;
        r.reviewWrap.style.opacity = '1';
      }, 320);
    });
  };

  if (track && track.children.length > 2) {
    const items = [...track.children];
    const realCount = items.length - 1;
    let idx = 0;
    const step = () => {
      idx += 1;
      const h = items[0].getBoundingClientRect().height || 17;
      track.style.transition = 'transform 0.45s cubic-bezier(0.22, 1, 0.36, 1)';
      track.style.transform = 'translateY(' + -idx * h + 'px)';
      if (hex) hex.style.color = items[idx % items.length].dataset.hexColor || '';
      if (idx === realCount) {

        setTimeout(() => {
          track.style.transition = 'none';
          track.style.transform = 'translateY(0)';
          idx = 0;
        }, 500);
      }
      swapReviews();
    };
    timers.push(setInterval(step, 2800));
  } else if (reviewWraps.length) {
    timers.push(setInterval(swapReviews, 2800));
  }
}

function initAllProcladHeroes() {
  document.querySelectorAll('[data-proclad-hero]').forEach(initProcladHero);
}

initAllProcladHeroes();
document.addEventListener('shopify:section:load', initAllProcladHeroes);
document.addEventListener('shopify:section:unload', (e) => {
  const root = e.target.querySelector('[data-proclad-hero]');
  const timers = root && heroTimers.get(root);
  if (timers) timers.forEach(clearInterval);
});
